import $ from "jquery";

export const OTHER = "__other__";

/**
 * For every ``<select>`` that carries a ``data-other-fields`` attribute,
 * show/hide the listed fields when the select value equals ``__other__``.
 *
 * ``data-other-fields`` is a comma-separated list of field names.
 * Each field's closest ``.form-group`` ancestor is toggled.
 * Hidden inputs are skipped — they have no wrapper of their own in
 * Django's ``as_div()`` output.
 *
 * Must be called **after** Select2 initialisation so ``.val()`` works.
 */
export function initOtherFieldsToggle(target) {
  $("select[data-other-fields]", target).each(function () {
    const $select = $(this);
    const names = $select
      .attr("data-other-fields")
      .split(",")
      .map((n) => n.trim())
      .filter(Boolean);
    if (!names.length) return;

    const selector = names
      .map((n) => `[name='${n}']`)
      .join(",");
    const $fields = $(selector, target).filter(":not([type='hidden'])");

    function toggle() {
      const isOther = $select.val() === OTHER;
      $fields.each(function () {
        const $wrapper = $(this).closest(".form-group");
        if (isOther) {
          $wrapper.show();
          $(this).prop("disabled", false);
        } else {
          $wrapper.hide();
          $(this).prop("disabled", true);
        }
      });
    }

    $select.on("change", toggle);
    toggle();
  });
}
